import React from 'react';

export const Buttons = ({
  t,
  isDemo,
  handleClickBet,
  isBetBtnDisabled,
  betPendingToggle,
  activeFreeBet,
  odd,
  wageringOdd,
}) => {
  return (
    <div className='w-md-bet-buttons'>
      <button
        type='button'
        onClick={handleClickBet}
        disabled={isBetBtnDisabled || betPendingToggle}
        className={`w-md-bet-button type-1
         ${isBetBtnDisabled || betPendingToggle ? 'disabled' : 'active'}
         ${
           (!isBetBtnDisabled && !betPendingToggle && !activeFreeBet.id && wageringOdd < odd) ||
           ((activeFreeBet.minOdd < odd || odd === 0) && !isDemo && !isBetBtnDisabled && !betPendingToggle)
             ? 'pulsation'
             : ''
         }
         ${
           !isDemo && (activeFreeBet.id || wageringOdd)
             ? `free-bet${(activeFreeBet.minOdd > odd || wageringOdd > odd) && odd > 0 ? '-disabled' : ''}`
             : ''
         }`}
      >
        <span className='w-md-bet-btn-txt' title={t('BET')}>
          {activeFreeBet.id && !isDemo ? `${t('FREE_BET')} ${activeFreeBet.remainingCount}` : t('BET')}
        </span>

        <span className='w-md-bet-btn-small-txt' title='min. odd x10'>
          {((activeFreeBet.id && !activeFreeBet.isMinOddNull) || wageringOdd) && !isDemo
            ? `${t('MIN_ODD')} x${activeFreeBet.minOdd || wageringOdd}`
            : ''}
        </span>

        {betPendingToggle && (
          <div
            className='circle-loader'
            style={{
              width: '4rem',
              height: '4rem',
            }}
          />
        )}
      </button>
    </div>
  );
};
